export default __webpack_public_path__ + "static/media/planbot_icon.aa7164d0.svg";